/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Utils
 */

module.exports = {

    Array: require('./array/'),
    Objects: require('./object/'),
    String: require('./string/')

};



//////////////////
// WEBPACK FOOTER
// ./utils/index.js
// module id = 977
// module chunks = 0